var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.334 5.833h13.333M8.334 9.167v5m3.333-5v5m-7.5-8.334.834 10A1.666 1.666 0 0 0 6.667 17.5h6.667a1.667 1.667 0 0 0 1.667-1.667l.833-10m-8.333 0v-2.5a.833.833 0 0 1 .833-.833h3.333a.833.833 0 0 1 .834.833v2.5"
  })));
};
export default SvgTrash;